import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher';

const navLinks = [
  { key: 'nav.home', path: '/' },
  { key: 'nav.schedule', path: '/schedule' },
  { key: 'nav.coaches', path: '/coaches' },
  { key: 'nav.pricing', path: '/pricing' },
  { key: 'nav.faq', path: '/faq' },
];

export default function Navbar() {
  const { t } = useTranslation('common');
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-slate-200">
      <nav className="max-w-5xl mx-auto px-4 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2" aria-label="BJJ CORE JAPAN ホーム">
          <img src="/logo.png" alt="BJJ CORE JAPAN" className="h-10 w-10 object-contain" />
          <span className="text-base font-bold text-slate-800 leading-tight hidden sm:block">
            BJJ CORE JAPAN
          </span>
        </Link>

        {/* Desktop nav */}
        <ul className="hidden md:flex gap-8">
          {navLinks.map(({ key, path }) => (
            <li key={key}>
              <Link
                to={path}
                className={`text-sm font-medium transition-colors duration-200 ${
                  location.pathname === path
                    ? 'text-primary border-b-2 border-primary pb-0.5'
                    : 'text-slate-600 hover:text-primary'
                }`}
              >
                {t(key)}
              </Link>
            </li>
          ))}
        </ul>

        {/* Language switcher — desktop */}
        <div className="hidden md:block">
          <LanguageSwitcher />
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden p-3 rounded text-slate-600 hover:text-primary focus:outline-none focus:ring-2 focus:ring-primary"
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="メニューを開く"
          aria-expanded={menuOpen}
        >
          <span className="block w-5 h-0.5 bg-current mb-1.5"></span>
          <span className="block w-5 h-0.5 bg-current mb-1.5"></span>
          <span className="block w-5 h-0.5 bg-current"></span>
        </button>
      </nav>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden border-t border-slate-100 bg-white">
          <ul className="flex flex-col px-4 py-2">
            {navLinks.map(({ key, path }) => (
              <li key={key}>
                <Link
                  to={path}
                  onClick={() => setMenuOpen(false)}
                  className={`block py-4 text-sm font-medium border-b border-slate-100 ${
                    location.pathname === path
                      ? 'text-primary'
                      : 'text-slate-600 hover:text-primary'
                  }`}
                >
                  {t(key)}
                </Link>
              </li>
            ))}
            <li className="py-4">
              <LanguageSwitcher />
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
